module.exports = __webpack_public_path__ + "static/media/zhangqianze.9185b226.jpg";